// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hei8","col":"styles_col__Q96MQ","actions":"styles_actions__1lTMF","conflict":"styles_conflict___VgNz"};